export const initialState = {
  termAndConditions: [],
  termAndCondition: {},
  publishTermAndConditionPage: {}
};
